import type {
  NewRelicConfig,
  NewRelicInfo
} from "@dealer-center/core-interfaces-third-party-newrelic";
import { NewRelic } from ".";
import scriptHtml from "./script";

const errorsToIgnore = ["ResizeObserver loop limit exceeded"];

const buildScriptHtml = (config: NewRelicConfig) => {
  const script = document.createElement("script");

  const infoConfig: NewRelicInfo = {
    beacon: "bam.nr-data.net",
    errorBeacon: "bam.nr-data.net",
    sa: 1,
    ...config
  };
  script.innerHTML = scriptHtml(config, infoConfig);
  script.setAttribute("data-testid", "newrelic-script");
  return script;
};
const buildStandardScript = () => {
  const script = document.createElement("script");
  script.setAttribute("src", "newrelic.js");
  script.setAttribute("data-testid", "newrelic-script-standard");
  script.setAttribute("crossorigin", "anonymous");
  script.setAttribute("type", "text/javascript");
  return script;
};

export const isInitialized = () => {
  const script = document.querySelector(
    'script[data-testid="newrelic-script"]'
  );
  return !!script;
};
export function initialize(config: NewRelicConfig) {
  if (!config || !config.agentID || !config.applicationID) return false;
  const standardScriptTag = buildStandardScript();
  document.head.insertBefore(standardScriptTag, document.head.childNodes[0]);
  const scriptTag = buildScriptHtml(config);
  document.head.insertBefore(scriptTag, document.head.childNodes[0]);
  NewRelic.setErrorHandler(err =>
    errorsToIgnore.includes((err as Error).message)
  );
  return true;
}
